<div class="searchresult">
    <his-search-form-result
        #SearchFormResultComponent
        searchConfigFile="fs/res/searchResPersonsPatent.xml"
        [genericSearchRowTooltipId]="'CONCAT(Person.firstname,\' \',Person.surname,\' \',[PersonOrgunitRelation].affiliationType.defaulttext)'"
        [resultRowsPerPage]="10"
        [singleSelect]="true"
        [isSearchPopup]="true"
        [hisIcon]="'arrow_right'"
        (onSubmitSelection)="onSubmitSelection($event)">
    </his-search-form-result>
</div>
